<template>
  <div class="bg-white rounded p-2 shadow-sm">
    <div>
      <h5 class="text-main px-1 ">
        {{ title }}
      </h5>
    </div>
    <div class="custom-height">
      <ul class="p-0 px-1 m-0 ">
        <li
          v-for="item in requestInfo"
          :key="item.id "
          class="px-0 mt-1"
        >
          <div class="d-flex">
            <div
              class="custom-size"
              :style="{ backgroundColor: item.elipseColor}"
            />
            <div class="text-main">
              <strong>{{ item.title }}</strong> <span class="text-secondary">{{ item.size }}</span>
              <div>
                {{ item.description }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <vue-apex-charts
      class="responsive-chart"
      type="bar"
      height="280"
      :options="computedChartOptions"
      :series="requestDetails"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'SimpleDonutChart',
  components: {
    VueApexCharts,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    requestInfo: {
      type: Array,
      default: () => ([]),
    },
    requestDetails: {
      type: [Array],
      default: () => ([]),
    },
    timeStamps: {
      type: [Array, Object],
      default: () => ([]),
    },
    barColors: {
      type: [Array, Object],
      default: () => ([]),
    },
  },
  computed: {
    calculateTickAmount() {
      const tickAmount = Math.ceil(this.timeStamps.length / 6)
      return tickAmount <= 10 ? 10 : tickAmount
    },
    computedChartOptions() {
      const chartOptions = {
        chart: {
          type: 'bar',
          height: 280,
          stacked: true,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        stroke: {
          width: 1,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
          },
        },
        xaxis: {
          categories: this.timeStamps,
          labels: {
            formatter: value => {
              const unixTimeStamp = parseInt(value, 10)
              return `${this.timeSince(unixTimeStamp, true)} ago`
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        noData: {
          text: 'Data Unavailable: Currently, no data is being returned.',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: -15,
          style: {
            color: '#7483A1',
            fontSize: '14px',
            fontFamily: undefined,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          show: false,
        },
        tooltip: {
          shared: true,
          intersect: false,
          x: {
            formatter: value => `${this.unixTimestampToDateTime(value)}`,
          },
          y: {
            formatter: value => `${value} request${value !== 1 ? 's' : ''}`,
          },
        },
        colors: this.barColors,
        responsive: [
          {
            breakpoint: 2560,
            options: {
              xaxis: {
                tickAmount: this.calculateTickAmount,
              },
            },
          },
          {
            breakpoint: 769,
            options: {
              xaxis: {
                tickAmount: this.calculateTickAmount,
              },
            },
          },
          {
            breakpoint: 426,
            options: {
              xaxis: {
                tickAmount: this.calculateTickAmount,
              },
            },
          },
        ],
      }
      return chartOptions
    },
  },
}
</script>

<style scoped>

.custom-size{
  width: 6px;
  height: 6px;
  border-radius: 10px;
  margin-top: 8px;
  margin-right: 5px;
}

.custom-height{
  height: 120px;
  overflow-y: auto;
}

ul {
  list-style: none;
}
 .responsive-chart {
   width: 90%; /* Chart will take 100% width on all screen sizes */
 }

 @media (min-width: 220px) {
  .responsive-chart {
      width: 100%; /* Adjust the height for larger screens (e.g., tablets) */
   }
 }

 @media (min-width: 992px) {
   .responsive-chart {
      width: 70%; /* Adjust the height for larger screens (e.g., tablets) */
   }
 }

 @media (min-width: 1200px) {
   .responsive-chart {
    width: 100%; /* Adjust the height for even larger screens (e.g., desktops) */
   }
 }

 @media (min-width: 1600px) {
   .responsive-chart {
    width: 95%; /* Adjust the height for even larger screens (e.g., desktops) */
   }
 }
</style>
